import Loader from './Loader.jsx';
import './Loader.css';

export default Loader;
